import { Box, Button, FormControl, styled, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { GridDeleteIcon } from '@mui/x-data-grid';

interface Props {
  imagemCapa: File | null;
  imagemUrl: string | null;
  onFileChange: (file: File) => void;
  onDelete: () => void;
}
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

export default function CapaUpload({ imagemCapa, imagemUrl, onFileChange, onDelete }: Props) {
  return (
    <Box>
      <FormControl fullWidth>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          //disabled={publicacao.id && publicacao.imagem ? true : false}
          startIcon={<CloudUploadIcon />}
          sx={{ textTransform: 'none' }} // Adicione esta linha
        >
          Selecione - {imagemCapa ? imagemCapa.name : 'Nenhum selecionado'}
          <VisuallyHiddenInput
            type="file"
            onChange={e => e.target.files && onFileChange(e.target.files[0])}
            //multiple
            accept="image/*" // Aceita apenas imagens e PDFs
          />
        </Button>
      </FormControl>
      {imagemUrl && (
        <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
          <img src={imagemUrl} alt="Miniatura" style={{ maxWidth: '100%', maxHeight: '150px' }} />
          <Button variant="outlined" color="error" onClick={onDelete} sx={{ mt: 1 }}>
            <GridDeleteIcon color="secondary" />
          </Button>
        </Box>
      )}
    </Box>
  );
}
